export const getAllLocations = () =>
    `query getAllLocations {
      locations {
        id
        name
        pocOperationsId
        childrenLocations {
          id
          name
          pocOperationsId
        }
        parentLocation {
          id
          name
          pocOperationsId
        }
      }
    }`;
